/**
 * Presentational body for the reassign-order modal.
 * @module reAssignModal/components/ReAssignModalBody
 */

import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import {
  REASSIGN_MODAL_ASSIGNED_TO_TEXT,
  REASSIGN_MODAL_NOT_ASSIGNED_TEXT,
  REASSIGN_MODAL_REASSIGN_TO_TEXT,
  REASSIGN_MODAL_SELECT_MEMBER_TEXT,
  UNASSIGNED_TEXT,
} from "../../../../constants/stringLiterals";
import { ProviderSelectOption } from "../types";

/** Props for {@link ReAssignModalBody}. */
export interface ReAssignModalBodyProps {
  /** Display name of the current assignee. */
  assignedTo?: string;
  /** Provider document id of the current assignee. */
  assignedToId?: string;
  /** Selected provider id bound to the searchable select. */
  providerId: string;
  /** Provider dropdown options from {@link buildProviderSelectOptions}. */
  options: ProviderSelectOption[];
  /** Called when the user picks a new provider in the select. */
  onProviderChange: (providerId: string) => void;
}

/**
 * Renders current assignee and provider picker inside the reassign modal.
 *
 * @param props - Assignee display and select configuration
 * @returns Modal body layout
 */
export const ReAssignModalBody = ({
  assignedTo,
  assignedToId,
  providerId,
  options,
  onProviderChange,
}: ReAssignModalBodyProps) => (
  <div className="reassign-modal--layout">
    {assignedTo && (
      <div className="reassign-modal--assigned">
        {assignedToId === UNASSIGNED_TEXT ? (
          REASSIGN_MODAL_NOT_ASSIGNED_TEXT
        ) : (
          <>
            {REASSIGN_MODAL_ASSIGNED_TO_TEXT} <span>{assignedTo}</span>
          </>
        )}
      </div>
    )}
    <div className="reassign-modal--reassign-to">
      <SearchableSelect
        id="reassign-to"
        onOptionChange={(option) => onProviderChange(option.value)}
        label={REASSIGN_MODAL_REASSIGN_TO_TEXT}
        placeholder={REASSIGN_MODAL_SELECT_MEMBER_TEXT}
        searchPlaceholder="Search providers"
        value={providerId}
        options={options}
      />
    </div>
  </div>
);
